document.addEventListener("alpine:init", () => {
  // --- HELPER FUNCTION FOR INSTANT DATA ---
  // This checks the global Liquid variable first.
  // If data exists, it returns instantly (0ms).
  // If not, it fetches only once per product and saves it.
  async function getProductData(handle) {
    // 1. Check Liquid Cache
    if (window.productDataCache && window.productDataCache[handle]) {
      return window.productDataCache[handle];
    }

    // 2. Fallback: Network Fetch (only happens if cache is empty)
    try {
      const response = await fetch(
        window.Shopify.routes.root + `products/${handle}.js`,
      );
      const data = await response.json();

      // Save to cache for next time
      window.productDataCache = window.productDataCache || {};
      window.productDataCache[handle] = data;

      return data;
    } catch (e) {
      console.error("Error fetching product data", e);
      return null;
    }
  }

  Alpine.data("mainProduct", (element, sectionID) => ({
    init() {
      this.stickyATC = false;
      this.currentVariantId = Number(element.dataset.currentVariantId);
      this.currentVariantTitle = element.dataset.currentVariantTitle;
      this.currentVariantPrice = element.dataset.currentVariantPrice;
      this.currentVariantCompareAtPrice =
        element.dataset.currentVariantCompareAtPrice;
      this.handle = element.dataset.productHandle;
      this.productGallery =
        document.querySelector("#product-gallery").innerHTML;
      this.selectedQuantity = 3;
      this.freeGiftId = Number(element.dataset.freeGiftId);
      this.totalPrice = "";
      this.productOne = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productTwo = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productThree = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productFour = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productFive = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productSix = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productSeven = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productEight = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.initSlider();
      this.initVideoPlay();
      this.initVideoSlider();

      // Hide gallery spinners on initial load
      this._initSpinnerHideTimeout = setTimeout(() => {
        const el = document.querySelector("#product-gallery");
        if (el) {
          el.querySelectorAll(".loading-spinner").forEach((s) => {
            s.style.display = "none";
          });
        }
        this._initSpinnerHideTimeout = null;
      }, 100);
    },

    initSlider() {
      if (window.innerWidth > 999) {
        this.thumbs = new Swiper(this.$refs.sliderThumbs, {
          slidesPerView: "auto",
          spaceBetween: 8,
          mousewheel: {
            releaseOnEdges: true,
          },
        });
      }
      this.main = new Swiper(this.$refs.sliderMain, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        thumbs: {
          swiper: this.thumbs,
        },
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: document.querySelector(".swiper-button-prev-custom"),
          prevEl: document.querySelector(".swiper-button-next-custom"),
        },
        breakpoints: {
          1000: {
            // At width >= 1000px, disable pagination
            pagination: false,
          },
        },
      });
    },

    updateSliderImages(variantId) {
      const slides = document.querySelectorAll(".swiper-slide[variant-id]");

      slides.forEach((slide) => {
        if (Number(slide.getAttribute("variant-id")) !== variantId) {
          slide.remove();
        }
      });
    },
    async fetchGallery() {
      const productGallery = document.querySelector("#product-gallery");
      if (!productGallery) return;

      // Clear any previous hide timeout and init hide timeout
      if (this._gallerySpinnerHideTimeout != null) {
        clearTimeout(this._gallerySpinnerHideTimeout);
        this._gallerySpinnerHideTimeout = null;
      }
      if (this._initSpinnerHideTimeout != null) {
        clearTimeout(this._initSpinnerHideTimeout);
        this._initSpinnerHideTimeout = null;
      }

      const galleryHeight = productGallery.offsetHeight;
      productGallery.style.height = `${galleryHeight}px`;

      productGallery.innerHTML = this.productGallery;

      this._gallerySpinnerHideTimeout = setTimeout(() => {
        // Hide spinners first (scoped to gallery only)
        productGallery
          .querySelectorAll(".loading-spinner")
          .forEach((spinner) => {
            spinner.style.display = "none";
          });

        // Then clear height (in try/catch so hide always runs even if this throws)
        try {
          productGallery.style.height = "";
        } catch (_) {}

        this._gallerySpinnerHideTimeout = null;
      }, 2000);
    },

    updateTheThreeProducts(title) {
      const inputEls = document.querySelectorAll(
        `#but2get1 input[value="${title}"]`,
      );

      inputEls.forEach((el) => {
        el.checked = true;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },

    updateSticky(title) {
      if (Alpine.store("sync").isSyncing) return;
      Alpine.store("sync").isSyncing = true;

      const stickyInput = document.querySelector(
        `#stickyATC input[value="${title}"]`,
      );

      stickyInput.checked = true;
      stickyInput.dispatchEvent(new Event("change", { bubbles: false }));

      Alpine.store("sync").isSyncing = false;
    },
    handleCheckboxChange() {
      this.updateTotalPrice();
    },

    updateTotalPrice() {
      if (this.selectedQuantity === 1) {
        this.totalPrice = this.currentVariantPrice;
      } else if ([3, 6, 8].includes(this.selectedQuantity)) {
        this.totalPrice = this.priceSumFor(this.selectedQuantity);
      } else {
        this.totalPrice = 0;
      }
    },

    initVideoPlay() {
      const videoWrappers = document.querySelectorAll(".video-wrapper");
      if (!videoWrappers.length) return;

      videoWrappers.forEach(function (videoWrapper) {
        const posterImageWrapper = videoWrapper.querySelector(
          ".poster-image-wrapper",
        );
        const videoElement = videoWrapper.querySelector("video");

        if (posterImageWrapper && videoElement) {
          posterImageWrapper.addEventListener("click", function () {
            posterImageWrapper.style.display = "none";
            videoElement.play();
            videoElement.classList.remove("hidden");
          });

          videoElement.addEventListener("play", function () {
            posterImageWrapper.style.display = "none";
          });

          videoElement.addEventListener("pause", function () {
            if (videoElement.currentTime === 0 || videoElement.ended) {
              posterImageWrapper.style.display = "flex";
            }
          });
        }
      });
    },
    initVideoSlider() {
      if (!this.$refs.videoSlider) return;
      this.videoSlider = new Swiper(this.$refs.videoSlider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });

      if (!this.$refs.videoSliderDesktop) return;
      this.videoSlider = new Swiper(this.$refs.videoSliderDesktop, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });
    },
    sumNumbers(...vals) {
      return vals.reduce((t, v) => t + (Number(v) || 0), 0);
    },
    _keyForIndex(i) {
      return [
        "productOne",
        "productTwo",
        "productThree",
        "productFour",
        "productFive",
        "productSix",
        "productSeven",
        "productEight",
      ][i - 1];
    },
    _paidUnitsFor(totalQty) {
      if (totalQty === 3) return 2; // B2G1
      if (totalQty === 6) return 3; // B3G3
      if (totalQty === 8) return 4; // B4G4
      return totalQty; // fallback
    },
    priceSumFor(totalQty) {
      const paid = this._paidUnitsFor(totalQty);
      const keys = Array.from({ length: paid }, (_, k) =>
        this._keyForIndex(k + 1),
      );
      return this.sumNumbers(...keys.map((k) => this[k]?.price));
    },
    compareSumFor(totalQty) {
      const keys = Array.from({ length: totalQty }, (_, k) =>
        this._keyForIndex(k + 1),
      );
      return this.sumNumbers(...keys.map((k) => this[k]?.compareAtPrice));
    },
    saveAmountFor(totalQty) {
      const compare = this.compareSumFor(totalQty);
      const due = this.priceSumFor(totalQty);
      return Math.max(compare - due, 0);
    },
    savePercentFor(totalQty) {
      const compare = this.compareSumFor(totalQty);
      if (!compare) return 0;
      return Math.round((this.saveAmountFor(totalQty) / compare) * 100);
    },
    async selectVariantFor(index, optionValue) {
      try {
        // OPTIMIZATION: Use helper instead of fetch
        const product = await getProductData(this.handle);

        // assumes 1st option is Color; extend if needed
        const matched = product.variants.find(
          (v) => v.options && v.options.includes(optionValue),
        );
        if (!matched) return;

        const key = this._keyForIndex(index);
        this[key].id = Number(matched.id);
        this[key].price = Number(matched.price);
        this[key].compareAtPrice = Number(matched.compare_at_price);

        this.updateTotalPrice();
      } catch (e) {
        console.error("selectVariantFor error", e);
      }
    },
    updateTheSixProducts(title) {
      const inputEls = document.querySelectorAll(
        `#but3get3 input[type="radio"][value="${title}"]`,
      );
      inputEls.forEach((el, idx) => {
        el.checked = true;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },
    updateTheEightProducts(title) {
      const inputEls = document.querySelectorAll(
        `#but4get4 input[type="radio"][value="${title}"]`,
      );
      inputEls.forEach((el) => {
        el.checked = true;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },
  }));

  Alpine.data("productOptions", (element, handle) => ({
    init() {
      this.findMatchingVariant();
    },
    async findMatchingVariant() {
      console.log(element);

      // OPTIMIZATION: Use helper instead of fetch
      const product = await getProductData(handle);

      var selectedOption = [];
      element
        .querySelectorAll('input[type="radio"]:checked')
        .forEach((radio) => {
          selectedOption.push(radio.value);
        });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      console.log(matchedVariant);

      if (matchedVariant) {
        this.currentVariantId = Number(matchedVariant.id);
        this.currentVariantTitle = matchedVariant.title;
        this.currentVariantPrice = matchedVariant.price;
        this.currentVariantCompareAtPrice = matchedVariant.compare_at_price;

        this.fetchGallery();
        // this.updateSliderImages(this.currentVariantTitle);
        this.updateSliderImages(matchedVariant.id);

        // Keep all three bundles in sync with the currently selected color
        this.updateTheThreeProducts(this.currentVariantTitle);
        this.updateTheSixProducts(this.currentVariantTitle);
        this.updateTheEightProducts(this.currentVariantTitle);

        this.updateSticky(this.currentVariantTitle);
      }

      setTimeout(() => {
        this.initSlider();
      }, 200);
    },
  }));

  Alpine.data("productOptionsFromProductSelector", (el, handle) => ({
    init() {},

    async findMatchingVariantFromProductSelector(selectorIndex) {
      // OPTIMIZATION: Use helper instead of fetch
      const product = await getProductData(handle);

      var selectedOption = [];
      el.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
        selectedOption.push(radio.value);
      });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      if (!matchedVariant) return;

      if (selectorIndex === 1) {
        this.productOne.id = matchedVariant.id;
        this.productOne.price = matchedVariant.price;
        this.productOne.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 2) {
        this.productTwo.id = matchedVariant.id;
        this.productTwo.price = matchedVariant.price;
        this.productTwo.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 3) {
        this.productThree.id = matchedVariant.id;
        this.productThree.price = matchedVariant.price;
        this.productThree.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 4) {
        this.productFour.id = matchedVariant.id;
        this.productFour.price = matchedVariant.price;
        this.productFour.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 5) {
        this.productFive.id = matchedVariant.id;
        this.productFive.price = matchedVariant.price;
        this.productFive.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 6) {
        this.productSix.id = matchedVariant.id;
        this.productSix.price = matchedVariant.price;
        this.productSix.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 7) {
        this.productSeven.id = matchedVariant.id;
        this.productSeven.price = matchedVariant.price;
        this.productSeven.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 8) {
        this.productEight.id = matchedVariant.id;
        this.productEight.price = matchedVariant.price;
        this.productEight.compareAtPrice = matchedVariant.compare_at_price;
      }

      this.updateTotalPrice();

      console.log(matchedVariant.price);
    },
  }));

  Alpine.data("productOptionsFromSticky", (el, handle) => ({
    async handleOptionClickSticky(value) {
      if (Alpine.store("sync").isSyncing) return;

      Alpine.store("sync").isSyncing = true;

      const checkbox = document.querySelector(
        `#product_options input[value="${value}"]`,
      );
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      Alpine.store("sync").isSyncing = false;
    },
  }));
});
